import storage from 'good-storage'
const util = {
  formatDate: function (date, fmt) {
    if (!date || date === '') return ''
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return fmt
  },
  // 分屏函数，用于确定视频预览的分屏的数值
  setPreviewLayout (num) {
    let layoutNum = 1
    // num为传入的数量，obj为控件对象
    if (num <= 0 || num > 16) {
      return layoutNum
    }
    if (num === 1) {
      layoutNum = 1
    } else if (num <= 4) {
      layoutNum = 2
    } else if (num <= 9) {
      layoutNum = 3
    } else if (num <= 16) {
      layoutNum = 5
    }
    return layoutNum
  },
  iframeDialog (obj, type, message) {
    const h = obj.$createElement
    obj.$message({
      message: h('span', { style: 'position:relative' }, [
        h('iframe', {
          style:
            'position:absoluteleft:-50pxtop:-10pxright:0pxbottom:0z-index:-1width:2000pxheight:40px'
        }),
        h('span', { style: 'white-space:nowrapcolor:#666' }, message)
      ]),
      type: type
    })
  },
  iframeConfigDialog (obj, message, sucCallBack) {
    const h = obj.$createElement
    obj
      .$msgbox({
        title: '消息',
        message: h('p', null, [
          h('span', { class: 'el-message-box__status h-icon-tip_question' }),
          h(
            'span',
            { style: 'font-size:12pxcolor:#666padding-left:50px' },
            message
          ),
          h('iframe', {
            style:
              'position:absoluteleft:-300pxtop:-200pxright:0pxbottom:0z-index:-1width:2000pxheight:500px'
          })
        ]),
        type: 'warming',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        beforeClose: (action, instance, done) => {
          done()
        }
      })
      .then(() => {
        sucCallBack()
      })
      .catch(() => {
        this.iframeDialog(obj, 'info', '已取消离开')
      })
  },
  // 计算一个容器的content高度，用于配合table的height属性实现表头固定
  getWrapperContentHeight (selector) {
    const className = selector.substring(1)
    const wrapperElement = document.querySelector(selector).parentNode
    // 如果有相邻节点，那么要去除相邻节点的高度
    const siblings = document.querySelector(selector).parentNode.children
    let siblingsHeight = 0
    for (let i = 0; i < siblings.length; i++) {
      if (siblings[i].className.indexOf(className) === -1) {
        siblingsHeight += siblings[i].offsetHeight
      }
    }
    const styleObj = window.getComputedStyle(wrapperElement)
    const offsetHeight = wrapperElement.offsetHeight
    const paddingTop = parseInt(styleObj.paddingTop, 10)
    const paddingBottom = parseInt(styleObj.paddingBottom, 10)
    return offsetHeight - paddingTop - paddingBottom - siblingsHeight
  },
  validateUrl (src) {
    let imgObj = new Image()
    imgObj.src = src
    if (imgObj.fileSize > 0 || (imgObj.width > 0 && imgObj.height > 0)) {
      return src
    } else {
      return ''
    }
  },
  isSystemConfiguration () {
    const { pathname } = window.location
    return /system-configuration/.test(pathname)
  },
  //判断浏览器是pc还是wap(手机端)
  isPc(){
    const userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
    var flag = true;
    for (var i = 0; i < Agents.length; i++) {
        if (userAgentInfo.includes(Agents[i])) {
            flag = false;
            break;
        }
    }
    return flag
  },
  isPortalPage(url){
    return url.includes('portal\/ui')
  },
  browserLangMap () {
    const key = storage.get('portal_language') || (navigator.language || navigator.browserLanguage)
    const map = {
      'en': 'en_US',
      'en_US': 'en_US',
      'zh-CN': 'zh_CN',
      'zh_CN': 'zh_CN'
    }
    return map[key] || 'zh_CN'
  }
}

export default util
